const homeContent = require("static/content/es/home.json");
const productsContent = require("static/content/es/products.json");
const resultsContent = require("static/content/es/results.json");

export default {
  home: homeContent,
  products: productsContent,
  results: resultsContent,
};
